export enum EBACnetDataTypes {
  "NULL" = 0,
  "BOOLEAN" = 1,
  "UNSIGNED_INTEGER" = 2,
  "SIGNED_INTEGER" = 3,
  "REAL" = 4,
  "DOUBLE" = 5,
  // "OCTET_STRING",
  // "CHARACTER_STRING",
  // "BIT_STRING",
  "ENUMERATION" = 9,
  // "DATE",
  // "TIME",
  // "OBJECT_IDENTIFIER",
}

export interface ITooltipElement extends HTMLElement {
  show: () => void;
  hide: () => void;
  trigger: "click" | "hover" | "manual";
  content: string;
}

export interface IPopupEvent {
  title?: string;
  desc?: string;
  primaryText?: string;
  secondaryText?: string;
}
